let footer = document.createElement('div');

footer.classList.add('footer');

footer.innerHTML = '<a href="http://sfawakenedmind.org" target="_blank">www.sfawakenedmind.org</a>';

export default footer;
